/** Shared branded IDs and primitive types. Keep this file dependency-free. */

export type JsonValue = string | number | boolean | null | JsonValue[] | { [k: string]: JsonValue };

export type NpcId = string;
export type ItemId = string;
export type CardId = string;
export type RoomId = string;
export type MonsterId = string;
export type QuestId = string;
export type DialogueId = string;
export type EasterEggId = string;
export type FactId = string;
export type EntityId = string;

export type ClassId = 'warrior' | 'rogue' | 'mage' | 'priest';

export type DiceMaterial = 'wood' | 'stone' | 'metal' | 'magic';

export type DiceSkin =
  | 'wooden'
  | 'iron'
  | 'ancient'
  | 'fate'
  | 'cursed'
  | 'golden'
  | 'ghost'
  | 'dragon';

export type Rarity = 'common' | 'uncommon' | 'rare' | 'epic' | 'legendary' | 'mythic';

export const RARITY_ORDER: readonly Rarity[] = [
  'common',
  'uncommon',
  'rare',
  'epic',
  'legendary',
  'mythic',
] as const;

/** GDD §4: the meaning of a d6 face, before class/situation modifiers. */
export type ResultBand = 'failure' | 'ordinary' | 'strong' | 'empowered' | 'critical';

export type Stat = 'might' | 'agility' | 'wits' | 'spirit';

export const STATS: readonly Stat[] = ['might', 'agility', 'wits', 'spirit'] as const;

export type Stats = Record<Stat, number>;

/** GDD §6 — personality traits accumulate from behaviour, never from a menu. */
export type Trait =
  | 'brave'
  | 'coward'
  | 'kind'
  | 'cruel'
  | 'greedy'
  | 'curious'
  | 'lucky'
  | 'honest'
  | 'deceptive';

export const TRAITS: readonly Trait[] = [
  'brave',
  'coward',
  'kind',
  'cruel',
  'greedy',
  'curious',
  'lucky',
  'honest',
  'deceptive',
] as const;

export type Traits = Partial<Record<Trait, number>>;
